import { Box } from '@mui/material';
import React, { FC, useMemo } from 'react';
import { BhiDialog } from 'src/UIKit';
import { FormView } from 'src/components/FormPart/FormView';
import { FormErrorRecord } from 'src/components/FormPart/types';
import { BlocklistEntryFormDialogController } from '../../controllers/BlocklistEntryFormDialogController';
import { BlocklistEntryFormData } from '../../types';
import { BlocklistEntryForm } from '../BlocklistEntryForm';

interface BlocklistEntryFormDialogProps extends BlocklistEntryFormDialogController {}

export const BlocklistEntryFormDialog: FC<BlocklistEntryFormDialogProps> = props => {
  const { isOpen, close, initFormData, error, submit } = props;

  const errorList: FormErrorRecord<BlocklistEntryFormData>[] | undefined = useMemo(() => {
    if (error?.error === 'conflict') {
      return [{ field: 'word', message: 'Entity with this name already exists' }];
    }
  }, [error]);

  return (
    <BhiDialog
      isOpen={isOpen}
      onClose={close}
      title={initFormData?.id ? 'Edit Blocklist Item' : 'Add to Blocklist'}
      maxWidth="sm"
    >
      {initFormData && (
        <Box px={2.5} pb={2.5}>
          <FormView
            formData={initFormData}
            component={BlocklistEntryForm}
            errorList={errorList}
            onSubmit={(full, dirty) => submit(full, dirty)}
          />
        </Box>
      )}
    </BhiDialog>
  );
};
